import React from "react";

interface Props {
  className?: string;
  rotate?: "top" | "right" | "bottom" | "left";
  size?: number;
}

const rotationDegrees: Record<NonNullable<Props["rotate"]>, number> = {
  top: 180,
  right: -90,
  bottom: 0,
  left: 90,
};

const Arrow: React.FC<Props> = ({
  className,
  rotate = "bottom",
  size = 14,
}) => {
  const rotation = rotationDegrees[rotate];

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ transform: `rotate(${rotation}deg)` }}
    >
      <path
        d="M11.6663 7.00016L10.8438 6.17766L7.58301 9.43266V2.3335H6.41634V9.43266L3.16134 6.17183L2.33301 7.00016L6.99967 11.6668L11.6663 7.00016Z"
        fill="var(--icon)"
      />
    </svg>
  );
};

export default Arrow;
